/* Shufooni — review wall motion: slow drift, scroll push, drag with inertia (vanilla, no deps) */
(function () {
  'use strict';
  var sec = document.querySelector('[data-shf-vw]');
  if (!sec || sec.dataset.ready) return;
  sec.dataset.ready = '1';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window) || !window.requestAnimationFrame) return; /* rows stay native swipeable lists */

  sec.classList.add('is-live');

  /* entrance + count-up of the live Judge.me numbers */
  var nums = [].slice.call(sec.querySelectorAll('[data-to]'));
  nums.forEach(function (el) { el.textContent = el.getAttribute('data-to').indexOf('.') > -1 ? '0.0' : '0'; });
  function countUp() {
    nums.forEach(function (el) {
      var raw = el.getAttribute('data-to'), to = parseFloat(raw), dec = raw.indexOf('.') > -1 ? 1 : 0, t0 = 0;
      if (!isFinite(to)) { el.textContent = raw; return; }
      (function step(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 1500);
        k = 1 - Math.pow(1 - k, 3);
        el.textContent = k < 1 ? (to * k).toFixed(dec) : raw;
        if (k < 1) requestAnimationFrame(step);
      })(performance.now());
    });
  }
  var seen = new IntersectionObserver(function (es) {
    if (!es[0].isIntersecting) return;
    sec.classList.add('is-in'); countUp(); seen.disconnect();
  }, { threshold: 0.2 });
  seen.observe(sec);

  /* rows: clone each set once (aria-hidden) so the loop is seamless */
  var mobile = window.matchMedia && matchMedia('(max-width: 749px)').matches;
  var BASE = mobile ? 24 : 32; /* px per second */
  function cloneSet(ul, n) {
    for (var i = 0; i < n; i++) {
      var c = ul.children[i].cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      [].forEach.call(c.querySelectorAll('a'), function (a) { a.setAttribute('tabindex', '-1'); });
      ul.appendChild(c);
    }
  }
  var rows = [].slice.call(sec.querySelectorAll('.shf-vw__row')).map(function (ul) {
    var n = ul.children.length;
    if (!n) return null;
    cloneSet(ul, n);
    return { el: ul, n: n, dir: +ul.getAttribute('data-dir') || 1, x: 0, w: 1, f: 1, hold: false, drag: false, fling: 0 };
  }).filter(Boolean);
  if (!rows.length) return;

  function measure() {
    rows.forEach(function (r) {
      var a = r.el.children[0], b = r.el.children[r.n];
      r.w = Math.max(1, b.offsetLeft - a.offsetLeft);
      while (r.el.children.length < r.n * 4 && r.el.scrollWidth < r.w + window.innerWidth + 40) cloneSet(r.el, r.n);
    });
  }
  measure();
  rows.forEach(function (r) { if (r.dir < 0) r.x = -r.w * 0.37; });
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('load', measure);

  /* hover / focus pause, touch-hold pause, horizontal drag with inertia */
  rows.forEach(function (r) {
    var id = null, sx = 0, sy = 0, lx = 0, v = 0, moved = false;
    r.el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') r.hold = true; });
    r.el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && !r.drag) r.hold = false; });
    r.el.addEventListener('focusin', function () { r.hold = true; });
    r.el.addEventListener('focusout', function () { r.hold = false; });
    r.el.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      id = e.pointerId; sx = lx = e.clientX; sy = e.clientY; v = 0; moved = false; r.fling = 0;
      if (e.pointerType !== 'mouse') r.hold = true;
    });
    r.el.addEventListener('pointermove', function (e) {
      if (e.pointerId !== id) return;
      var dx = e.clientX - lx; lx = e.clientX;
      if (!r.drag) {
        var ax = Math.abs(e.clientX - sx);
        if (ax < 8 || ax < Math.abs(e.clientY - sy)) return;
        r.drag = moved = true; r.el.classList.add('is-drag');
        try { r.el.setPointerCapture(id); } catch (er) {}
      }
      r.x += dx; v = dx;
    });
    function end(e) {
      if (e.pointerId !== id) return;
      id = null;
      if (r.drag) { r.drag = false; r.fling = Math.max(-40, Math.min(40, v * 0.8)); r.el.classList.remove('is-drag'); }
      if (e.pointerType !== 'mouse') r.hold = false;
    }
    r.el.addEventListener('pointerup', end);
    r.el.addEventListener('pointercancel', end);
    r.el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  /* loop: runs only while the wall is on screen */
  var active = false, last = 0, boost = 0, lastY = window.pageYOffset;
  function frame(t) {
    if (!active) { last = 0; return; }
    var dt = last ? Math.min(0.05, (t - last) / 1000) : 0;
    last = t;
    var y = window.pageYOffset;
    boost = (boost + (y - lastY) * 0.32) * 0.9; /* scrolling pushes the wall; scrolling up pulls it back */
    lastY = y;
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      r.f += ((r.hold ? 0 : 1) - r.f) * 0.08;
      if (!r.drag) {
        if (r.fling) { r.x += r.fling; r.fling *= 0.92; if (Math.abs(r.fling) < 0.05) r.fling = 0; }
        r.x -= r.dir * (BASE * dt + boost * 0.2) * r.f;
      }
      r.x = ((r.x % r.w) - r.w) % r.w;
      r.el.style.transform = 'translate3d(' + r.x.toFixed(2) + 'px,0,0)';
    }
    requestAnimationFrame(frame);
  }
  new IntersectionObserver(function (es) {
    var on = es[0].isIntersecting;
    if (on && !active) { active = true; lastY = window.pageYOffset; boost = 0; requestAnimationFrame(frame); }
    else if (!on) active = false;
  }, { rootMargin: '150px 0px' }).observe(sec);
})();